// Modules
import useSWR from "swr";
// Actions
import { getData } from "../getDataAction";
// Helpers
import { sortByLocalCompare } from "@/helpers/sort";
import type { User } from "@/lib/types/types";

type GetPatientsSWRProps = {
    displaySpinner?: boolean;
    sharedPatients?: boolean;
};

export const getPatientsSWR = ({ displaySpinner, sharedPatients }: GetPatientsSWRProps = {}) => {
    const fetcher = ([url]: Array<string>) =>
        getData<User[]>({
            displaySpinner,
            params: { sharedPatients },
            url,
            sortDataBy: (...props) => sortByLocalCompare(...props, "child.name")
        });

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data } = useSWR(["/patient", sharedPatients], fetcher, {
        revalidateOnFocus: true,
        dedupingInterval: 5 * 60 * 1000 // 5 minutes
    });

    return data ?? [];
};
